import React from "react";
import { Crown, Medal, Diamond, Trophy } from "@phosphor-icons/react";

const CLIENT_TIERS = [
  { key: "diamante", label: "Diamante", min: 2000, color: "#5C7CFA", bg: "#E8EEFF", Icon: Diamond },
  { key: "ouro",     label: "Ouro",     min: 1000, color: "#C5A566", bg: "#F6EAD2", Icon: Crown },
  { key: "prata",    label: "Prata",    min: 500,  color: "#5C5A57", bg: "#EDEAE7", Icon: Medal },
  { key: "bronze",   label: "Bronze",   min: 0,    color: "#9C7155", bg: "#F2E3D8", Icon: Trophy },
];

export function clientTier(creditLimit) {
  const cl = Number(creditLimit || 0);
  return CLIENT_TIERS.find((t) => cl >= t.min) || CLIENT_TIERS[CLIENT_TIERS.length - 1];
}

export function ClientTierBadge({ credit_limit, compact = false }) {
  const t = clientTier(credit_limit);
  const Icon = t.Icon;
  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-1 text-[10px] uppercase tracking-widest font-bold"
        style={{ background: t.bg, color: t.color }}
        data-testid={`tier-badge-${t.key}`}
      >
        <Icon size={11} weight="fill" /> {t.label}
      </span>
    );
  }
  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5"
      style={{ background: t.bg, color: t.color, border: `1px solid ${t.color}` }}
      data-testid={`tier-badge-${t.key}`}
    >
      <Icon size={16} weight="fill" />
      <span className="text-xs tracking-widest uppercase font-bold">{t.label}</span>
    </div>
  );
}
